var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 38,
    viewBox: "0 0 200 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4322 36.8624C27.0592 36.8624 34.8634 29.0582 34.8634 19.4312C34.8634 9.80421 27.0592 2 17.4322 2C7.80519 2 0.000976562 9.80421 0.000976562 19.4312C0.000976562 29.0582 7.80519 36.8624 17.4322 36.8624Z",
    fill: "#4A4A4A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_308_1148",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 3,
    width: 33,
    height: 33
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3847 35.6494C26.3699 35.6494 33.6538 28.3655 33.6538 19.3803C33.6538 10.3951 26.3699 3.11121 17.3847 3.11121C8.39953 3.11121 1.1156 10.3951 1.1156 19.3803C1.1156 28.3655 8.39953 35.6494 17.3847 35.6494Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_308_1148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.383 36.9576C27.0887 36.9576 34.9566 29.0896 34.9566 19.3839C34.9566 9.67829 27.0887 1.8103 17.383 1.8103C7.67734 1.8103 -0.190643 9.67829 -0.190643 19.3839C-0.190643 29.0896 7.67734 36.9576 17.383 36.9576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1504 29.522C15.1504 29.522 16.8112 30.9464 15.19 31.8164C15.19 31.8164 18.3148 32.8052 20.2132 31.5788C20.2132 31.5788 18.9077 30.9068 20.134 29.3636L15.1504 29.522Z",
    fill: "#C19786"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M15.5195 29.4181C15.5195 29.4181 16.9907 30.8425 15.5549 31.7125C15.5549 31.7125 18.3213 32.7013 20.003 31.475C20.003 31.475 18.8475 30.8029 19.9332 29.2598L15.5205 29.4181H15.5195Z",
    fill: "url(#paint0_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4201 48.6279L20.5819 48.6081C20.5819 48.6081 21.9146 39.8859 21.9146 36.9976C21.9146 36.9976 20.807 32.3692 20.2141 31.5784L15.1908 31.8159C15.1908 31.8159 13.8457 35.6524 13.8853 37.0372C13.8853 37.0372 14.1155 41.7843 15.4211 48.6279H15.4201Z",
    fill: "#262524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1897 31.8156C15.1897 31.8156 14.8334 31.4988 13.2913 32.646L2.13608 39.9241L3.99493 40.3201L14.4697 34.3476L15.1887 31.8156H15.1897Z",
    fill: "#3A3838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.663 31.7636C20.663 31.7636 21.0193 31.4468 22.5614 32.594L33.7166 39.8721L31.8578 40.2681L21.383 34.2956L20.664 31.7636H20.663Z",
    fill: "#3A3838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8554 32.6878L17.3715 37.8027L18.1092 39.1354L18.8344 37.8298L19.9097 32.2324L15.8554 32.6878Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5022 32.0548L17.9773 31.9892L17.7001 31.6985L17.5022 32.0548Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3314 31.9621L18.2015 31.9225L18.4911 32.4372C18.4911 32.4372 18.1348 33.3604 18.0952 33.3604C18.0556 33.3604 17.5544 33.4135 17.5544 33.3739C17.5544 33.3343 17.0793 32.4247 17.0793 32.4247L17.3294 31.9631L17.3314 31.9621Z",
    fill: "#939292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5555 33.3736C17.5555 33.3736 17.8983 33.1496 18.0963 33.3601C18.0963 33.3601 19.0455 36.3932 18.835 37.83L18.1098 39.1356L17.3711 37.804C17.3711 37.804 17.3054 36.1035 17.5555 33.3736Z",
    fill: "#939292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1898 31.7767L15.7493 30.4191L17.7009 31.659C17.7009 31.659 17.4769 33.0438 16.264 33.175C16.264 33.175 15.394 32.8854 15.1898 31.7767Z",
    fill: "#EDECED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6923 30.3259L17.6751 31.6711C17.6751 31.6711 18.7264 33.731 19.5339 32.9235C19.6923 32.7651 19.9559 32.6339 20.2133 31.5784L19.6923 30.3259Z",
    fill: "#EDECED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8531 40.7178C17.8531 40.7178 18.5585 44.845 17.3186 46.981C17.3186 46.981 16.7122 48.4845 16.2371 48.6419L15.3931 48.7471C15.3931 48.7471 13.7447 37.5659 13.7187 34.5067L14.8398 32.1071L17.8531 40.7167V40.7178Z",
    fill: "#3A3838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.479 31.0857L17.8526 40.7175L14.5298 32.9445L15.0038 32.3121L14.0546 32.0151L15.479 31.0857Z",
    fill: "#424141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4401 40.4139C18.4401 40.4139 17.9921 47.2439 18.9413 48.2984L20.6553 48.3515C20.6553 48.3515 22.3579 37.2901 22.2985 34.456L20.8137 31.5802C20.8137 31.5802 18.4401 39.8867 18.4401 40.4139Z",
    fill: "#3A3838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9288 30.9083L18.3658 40.7381L21.076 33.1235L20.5019 32.6494L21.5501 31.719L19.9288 30.9083Z",
    fill: "#424141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5013 14.9268C29.6378 16.2469 23.8383 17.5952 16.804 17.5952C9.76975 17.5952 3.38777 16.2178 3.82956 14.9664C4.30469 13.6212 9.76975 12.7908 16.804 12.7908C23.8383 12.7908 29.3825 13.7796 29.5013 14.9268Z",
    fill: "#695447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.77115 14.9932L7.4628 26.8069C7.4628 26.8069 8.42557 29.8588 10.2052 29.7213L24.8676 29.1941C24.8676 29.1941 26.9578 29.0888 27.6632 26.3328L29.5617 14.7296C29.5617 14.7296 16.1652 15.5736 3.77115 14.9932Z",
    fill: "#DCC3B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.34381 15.1259L7.59055 26.0164C7.59055 26.0164 8.53144 29.0683 10.2715 28.9308L24.6036 28.4035C24.6036 28.4035 26.6469 28.2983 27.3356 25.5423L29.2237 14.8102C29.2237 14.8102 16.4586 15.7063 4.34277 15.1269L4.34381 15.1259Z",
    fill: "url(#paint1_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05748 15.0862C5.05748 15.0862 4.85951 18.6861 11.3467 21.5338L11.2675 20.2282C11.2675 20.2282 6.36305 18.5674 6.20467 15.1654L5.05748 15.0862Z",
    fill: "url(#paint2_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07353 15.1256L8.57708 15.2048C8.57708 15.2048 8.53748 17.42 7.39029 17.7763C7.39029 17.7763 6.67863 17.2231 6.63904 17.0251C6.63904 17.0251 7.15376 16.1155 7.07458 15.1267L7.07353 15.1256Z",
    fill: "url(#paint3_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72352 15.2422L7.94386 15.2026C7.94386 15.2026 7.31139 17.5762 9.84231 19.5143L10.7123 18.4858C10.7123 18.4858 8.7743 18.2483 9.72352 15.2422Z",
    fill: "url(#paint4_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.712 15.2815L11.9384 15.3211C11.9384 15.3211 14.3912 17.1403 11.3455 19.5139H9.84198C9.84198 19.5139 12.5709 18.1292 10.712 15.2815Z",
    fill: "url(#paint5_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6295 15.2815C14.6295 15.2815 13.7991 16.785 16.9239 20.3048L17.5959 19.1972C17.5959 19.1972 15.2224 17.2591 15.7767 15.2815H14.6295Z",
    fill: "url(#paint6_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6801 15.2838C20.6801 15.2838 21.6293 17.4198 18.3461 18.3295L18.5837 19.0015C18.5837 19.0015 22.539 18.764 21.7877 15.165L20.6801 15.2838Z",
    fill: "url(#paint7_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7378 15.1256L23.9642 15.2048C23.9642 15.2048 23.2922 18.0129 25.5855 19.2788L24.3987 19.9509C24.3987 19.9509 21.8272 17.5377 22.7378 15.1256Z",
    fill: "url(#paint8_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5863 15.006L27.2076 14.8872C27.2076 14.8872 28.4735 18.3684 20.7203 17.6161L20.9579 16.7065C20.9579 16.7065 25.8624 16.3897 25.5863 15.006Z",
    fill: "url(#paint9_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.315 14.8469C28.315 14.8469 29.8977 14.4905 28.513 18.526C28.513 18.526 27.6825 19.99 25.981 19.8316L25.6247 18.6844C25.6247 18.6844 26.6135 18.9616 27.1678 18.2093C27.1678 18.2093 28.1566 16.1129 27.2074 14.8865L28.315 14.8469Z",
    fill: "url(#paint10_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6929 17.6166C26.6929 17.6166 24.6756 14.3334 21.1549 16.4694L21.4716 17.2998C21.4716 17.2998 23.8056 16.0339 25.9812 18.4074L26.6929 17.6166Z",
    fill: "url(#paint11_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.228 17.0234C18.228 17.0234 15.6564 13.7798 12.9276 17.8143L13.5204 18.2102C13.5204 18.2102 15.8544 15.5595 17.3569 17.657L18.2269 17.0245L18.228 17.0234Z",
    fill: "url(#paint12_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0542 17.6567C23.0542 17.6567 20.641 13.8994 16.3294 17.3795L17.0807 18.0516C17.0807 18.0516 19.7314 15.5196 22.1831 18.2099L23.0532 17.6567H23.0542Z",
    fill: "url(#paint13_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6125 18.2113C12.6125 18.2113 12.8105 15.0468 9.05212 16.5504L8.97293 17.658C8.97293 17.658 11.1881 16.3128 11.4257 18.726L12.6125 18.2113Z",
    fill: "url(#paint14_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.9863,
    y: 14.0165,
    width: 4.5273,
    height: 15.3928,
    fill: "url(#pattern0_308_1148)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.1163,
    y: 13.8982,
    width: 4.5273,
    height: 15.3928,
    fill: "url(#pattern1_308_1148)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.82358,
    y: 15.328,
    width: 5.26813,
    height: 14.4051,
    fill: "url(#pattern2_308_1148)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.67712,
    y: 22.2787,
    width: 17.6976,
    height: 6.83211,
    fill: "url(#pattern3_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8009 15.4145L16.9965 15.4405C16.9965 15.4405 13.4924 12.6054 7.8137 15.0946L6.94992 14.8404C6.94992 14.8404 11.0625 12.3751 14.874 13.9193C14.874 13.9193 16.9402 14.2642 17.8009 15.4134V15.4145Z",
    fill: "url(#paint15_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7705 15.278L15.1901 15.3176C15.1901 15.3176 12.7238 12.9117 8.58095 15.2061L7.96411 15.0019C7.96411 15.0019 10.9785 12.7617 13.6928 14.0318C13.6928 14.0318 15.1745 14.2902 15.7705 15.2769V15.278Z",
    fill: "url(#paint16_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8673 15.9656L13.4745 16.0136C13.4745 16.0136 11.8678 14.0297 9.01805 16.075L8.60648 15.9156C8.60648 15.9156 10.6935 13.9421 12.494 14.957C12.494 14.957 13.488 15.1414 13.8663 15.9656H13.8673Z",
    fill: "url(#paint17_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5536 13.527L14.1608 13.5749C14.1608 13.5749 12.5541 11.591 9.70436 13.6364L9.29279 13.477C9.29279 13.477 10.9182 11.6692 13.3054 12.3944C13.3054 12.3944 14.1744 12.7028 14.5536 13.527Z",
    fill: "url(#paint18_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7062 13.751L18.3134 13.7989C18.3134 13.7989 16.7067 11.815 13.857 13.8604L13.4454 13.701C13.4454 13.701 15.0709 11.8932 17.458 12.6184C17.458 12.6184 18.327 12.9268 18.7062 13.751Z",
    fill: "url(#paint19_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5678 14.0413L21.175 14.0892C21.175 14.0892 19.5683 12.1053 16.7186 14.1507L16.307 13.9913C16.307 13.9913 17.9325 12.1835 20.3196 12.9087C20.3196 12.9087 21.1886 13.2171 21.5678 14.0413Z",
    fill: "url(#paint20_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1033 14.9954L20.6199 14.9465C20.6199 14.9465 19.2299 12.1332 15.26 13.8149L14.8099 13.5127C14.8099 13.5127 17.2481 11.7852 19.9134 13.3002C19.9134 13.3002 20.872 13.9056 21.1033 14.9954Z",
    fill: "url(#paint21_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M21.1033 14.9954L20.6199 14.9465C20.6199 14.9465 19.2299 12.1332 15.26 13.8149L14.8099 13.5127C14.8099 13.5127 17.2481 11.7852 19.9134 13.3002C19.9134 13.3002 20.872 13.9056 21.1033 14.9954Z",
    fill: "url(#paint22_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2148 13.1116L23.7365 13.198C23.7365 13.198 21.6214 10.8797 18.2725 13.595L17.7557 13.4293C17.7557 13.4293 19.6198 11.0943 22.6008 11.8112C22.6008 11.8112 23.6896 12.1269 24.2138 13.1105L24.2148 13.1116Z",
    fill: "url(#paint23_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8121 12.506L20.3338 12.5924C20.3338 12.5924 18.2186 10.2741 14.8698 12.9894L14.353 12.8238C14.353 12.8238 16.217 10.4887 19.1981 11.2056C19.1981 11.2056 20.2869 11.5213 20.811 12.5049L20.8121 12.506Z",
    fill: "url(#paint24_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5579 10.5804L24.1995 10.9076C24.1995 10.9076 21.1757 10.0667 19.7816 14.147L19.2564 14.2814C19.2564 14.2814 19.595 11.3118 22.5011 10.3366C22.5011 10.3366 23.592 10.0261 24.5589 10.5804H24.5579Z",
    fill: "url(#paint25_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7858 16.3981L27.3023 16.348C27.3023 16.348 25.9186 13.5316 21.9445 15.204L21.4944 14.9008C21.4944 14.9008 23.9368 13.1784 26.599 14.6997C26.599 14.6997 27.5565 15.3071 27.7858 16.3981Z",
    fill: "url(#paint26_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4456 16.2108L26.9621 16.2619C26.9621 16.2619 25.7576 14.651 23.0548 15.4022L21.0115 15.5471C21.0115 15.5471 23.0152 13.856 25.9337 14.7948C25.9337 14.7948 26.9965 15.1907 27.4456 16.2118V16.2108Z",
    fill: "url(#paint27_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4456 16.2108L26.9621 16.2619C26.9621 16.2619 25.7576 14.651 23.0548 15.4022L21.0115 15.5471C21.0115 15.5471 23.0152 13.856 25.9337 14.7948C25.9337 14.7948 26.9965 15.1907 27.4456 16.2118V16.2108Z",
    fill: "url(#paint28_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7255 15.91L30.3296 16.0277C30.3296 16.0277 28.7239 14.1616 25.6126 15.4015L24.8739 15.3484C24.8739 15.3484 26.7744 14.1731 29.3084 14.7045C29.3084 14.7045 30.2368 14.9525 30.7255 15.91Z",
    fill: "url(#paint29_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9526 15.8303L29.5546 15.7178C29.5546 15.7178 29.1368 12.8503 25.3013 13.911L25.0002 13.562C25.0002 13.562 27.5446 12.2491 29.4004 14.0538C29.4004 14.0538 30.0516 14.7602 29.9526 15.8303Z",
    fill: "url(#paint30_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3182 16.5181L28.9567 16.3181C28.9567 16.3181 29.2026 13.4308 25.2254 13.5913L25.0118 13.1828C25.0118 13.1828 27.7887 12.4826 29.1849 14.6624C29.1849 14.6624 29.6579 15.4991 29.3182 16.5181Z",
    fill: "url(#paint31_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M29.3182 16.5181L28.9567 16.3181C28.9567 16.3181 29.2026 13.4308 25.2254 13.5913L25.0118 13.1828C25.0118 13.1828 27.7887 12.4826 29.1849 14.6624C29.1849 14.6624 29.6579 15.4991 29.3182 16.5181Z",
    fill: "url(#paint32_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1568 17.3493L27.8901 17.0336C27.8901 17.0336 29.1457 14.4225 25.3717 13.1586L25.3165 12.7012C25.3165 12.7012 28.161 13.0336 28.6914 15.5676C28.6914 15.5676 28.8372 16.5179 28.1568 17.3493Z",
    fill: "url(#paint33_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M28.1568 17.3493L27.8901 17.0336C27.8901 17.0336 29.1457 14.4225 25.3717 13.1586L25.3165 12.7012C25.3165 12.7012 28.161 13.0336 28.6914 15.5676C28.6914 15.5676 28.8372 16.5179 28.1568 17.3493Z",
    fill: "url(#paint34_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5821 16.8176L28.2122 16.6321C28.2122 16.6321 28.3425 13.7376 24.3757 14.0564L24.1455 13.6574C24.1455 13.6574 26.8921 12.8478 28.3748 14.9702C28.3748 14.9702 28.8812 15.7871 28.5821 16.8186V16.8176Z",
    fill: "url(#paint35_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8517 16.0301L28.4391 16.052C28.4391 16.052 27.1147 13.4742 23.8295 15.7207L23.4314 15.4883C23.4314 15.4883 25.4132 13.4221 27.7545 14.5287C27.7545 14.5287 28.5995 14.9861 28.8517 16.0301Z",
    fill: "url(#paint36_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M28.8517 16.0301L28.4391 16.052C28.4391 16.052 27.1147 13.4742 23.8295 15.7207L23.4314 15.4883C23.4314 15.4883 25.4132 13.4221 27.7545 14.5287C27.7545 14.5287 28.5995 14.9861 28.8517 16.0301Z",
    fill: "url(#paint37_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0664 15.1126L19.3568 15.1897C19.3568 15.1897 14.9921 12.1837 9.69162 15.4002L8.80179 15.2616C8.80179 15.2616 12.5528 12.2754 16.5352 13.3038C16.5352 13.3038 19.0609 14.0863 20.0664 15.1126Z",
    fill: "url(#paint38_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4958 10.3772C23.4958 10.3772 19.105 12.1569 18.6893 15.4401L19.3019 15.5588C19.3019 15.5588 19.5593 12.5528 24.2856 11.0295C24.2856 11.0295 23.7907 10.3772 23.4948 10.3772H23.4958Z",
    fill: "url(#paint39_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4958 10.3234C23.4958 10.3234 19.105 12.103 18.6893 15.3862L19.3019 15.505C19.3019 15.505 19.5593 12.499 24.2856 10.9756C24.2856 10.9756 23.7907 10.3234 23.4948 10.3234H23.4958Z",
    fill: "url(#paint40_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1781 15.2404L10.0085 15.3988C10.0085 15.3988 16.4562 9.34712 21.4003 9.54405C21.4003 9.54405 26.4631 10.2161 24.921 15.3592L26.0286 15.28C26.0286 15.28 28.0854 10.2172 21.8754 8.71361C21.8754 8.71361 16.575 7.80398 9.1781 15.2404Z",
    fill: "url(#paint41_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.68488 15.1649L6.37361 15.2118C6.37361 15.2118 7.054 9.87387 13.4131 11.3597C20.1003 12.9216 19.0292 15.3514 19.0292 15.3514L20.1431 15.3045C20.1431 15.3045 20.2358 11.6379 13.7382 10.5699C7.24051 9.50189 6.12667 12.0088 5.68488 15.1649Z",
    fill: "url(#paint42_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5356 15.3033C10.5356 15.3033 9.74684 8.66606 6.3115 10.6156C2.87721 12.5651 4.91945 15.0251 4.91945 15.0251L5.68529 15.1647C5.68529 15.1647 3.75871 13.0756 6.68348 11.2199C6.68348 11.2199 8.87576 9.87785 9.85103 15.494L10.1803 15.6128L10.5356 15.3044V15.3033Z",
    fill: "url(#paint43_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.173 13.757C20.173 13.757 18.2474 21.0413 7.61008 21.2455C-2.09054 21.431 1.01971 15.1188 1.01971 15.1188C1.01971 15.1188 2.56701 12.0554 6.37328 15.2115L5.29069 15.1959C5.29069 15.1959 2.91503 13.9289 1.94913 15.8607C1.06764 17.6247 2.18149 18.8771 2.18149 18.8771C2.18149 18.8771 3.66628 20.3619 7.48818 20.2233C12.4802 20.041 15.9978 18.8313 19.5561 13.6944C19.5561 13.6944 19.9271 13.2922 20.175 13.7559L20.173 13.757Z",
    fill: "url(#paint44_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M20.173 13.757C20.173 13.757 18.2474 21.0413 7.61008 21.2455C-2.09054 21.431 1.01971 15.1188 1.01971 15.1188C1.01971 15.1188 2.56701 12.0554 6.37328 15.2115L5.29069 15.1959C5.29069 15.1959 2.91503 13.9289 1.94913 15.8607C1.06764 17.6247 2.18149 18.8771 2.18149 18.8771C2.18149 18.8771 3.66628 20.3619 7.48818 20.2233C12.4802 20.041 15.9978 18.8313 19.5561 13.6944C19.5561 13.6944 19.9271 13.2922 20.175 13.7559L20.173 13.757Z",
    fill: "url(#paint45_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M20.173 13.757C20.173 13.757 18.2474 21.0413 7.61008 21.2455C-2.09054 21.431 1.01971 15.1188 1.01971 15.1188C1.01971 15.1188 2.56701 12.0554 6.37328 15.2115L5.29069 15.1959C5.29069 15.1959 2.91503 13.9289 1.94913 15.8607C1.06764 17.6247 2.18149 18.8771 2.18149 18.8771C2.18149 18.8771 3.66628 20.3619 7.48818 20.2233C12.4802 20.041 15.9978 18.8313 19.5561 13.6944C19.5561 13.6944 19.9271 13.2922 20.175 13.7559L20.173 13.757Z",
    fill: "url(#paint46_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5281 13.7196C19.5281 13.7196 19.2624 13.0131 18.6435 13.7248C18.6435 13.7248 11.5748 20.0317 6.2223 18.8564C0.868728 17.6811 2.57128 13.7821 4.14881 13.5341C4.14881 13.5341 4.9532 13.4726 4.8292 14.2145L5.29287 14.4312C5.29287 14.4312 5.48668 12.8839 4.02377 12.8839C2.56086 12.8839 1.45535 14.3687 1.42409 16.3182C1.39283 18.2677 4.17798 19.6598 6.28169 19.8452C8.3854 20.0307 13.9557 19.5972 19.525 13.7185L19.5281 13.7196Z",
    fill: "url(#paint47_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M19.5281 13.7196C19.5281 13.7196 19.2624 13.0131 18.6435 13.7248C18.6435 13.7248 11.5748 20.0317 6.2223 18.8564C0.868728 17.6811 2.57128 13.7821 4.14881 13.5341C4.14881 13.5341 4.9532 13.4726 4.8292 14.2145L5.29287 14.4312C5.29287 14.4312 5.48668 12.8839 4.02377 12.8839C2.56086 12.8839 1.45535 14.3687 1.42409 16.3182C1.39283 18.2677 4.17798 19.6598 6.28169 19.8452C8.3854 20.0307 13.9557 19.5972 19.525 13.7185L19.5281 13.7196Z",
    fill: "url(#paint48_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4551 13.8976C16.4551 13.8976 14.7015 13.4277 14.2826 15.4897L14.267 15.6512L14.8473 15.2803C14.8473 15.2803 15.0589 14.4874 16.2186 14.3592L16.4561 13.8976H16.4551Z",
    fill: "url(#paint49_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7117 14.4625C17.7117 14.4625 17.1261 13.9436 15.8726 14.5625C14.6192 15.1814 12.2373 17.6571 7.40987 17.7957C2.58248 17.9353 4.76434 14.2374 5.6302 14.6084C5.6302 14.6084 5.6375 13.8425 4.82581 14.0051C4.23502 14.1228 3.84012 14.3281 3.43376 15.5597C2.9232 17.107 4.64868 18.5522 6.49711 18.7387C8.33095 18.9241 10.1867 19.0867 15.9893 15.4899C15.9893 15.4899 16.701 14.8438 17.1188 14.9366L17.7117 14.4614V14.4625Z",
    fill: "url(#paint50_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M17.7117 14.4625C17.7117 14.4625 17.1261 13.9436 15.8726 14.5625C14.6192 15.1814 12.2373 17.6571 7.40987 17.7957C2.58248 17.9353 4.76434 14.2374 5.6302 14.6084C5.6302 14.6084 5.6375 13.8425 4.82581 14.0051C4.23502 14.1228 3.84012 14.3281 3.43376 15.5597C2.9232 17.107 4.64868 18.5522 6.49711 18.7387C8.33095 18.9241 10.1867 19.0867 15.9893 15.4899C15.9893 15.4899 16.701 14.8438 17.1188 14.9366L17.7117 14.4614V14.4625Z",
    fill: "url(#paint51_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4786 15.4191C14.4786 15.4191 12.4853 9.40807 7.79756 11.2878C7.79756 11.2878 5.1364 12.3558 6.37425 15.2097L7.21719 15.2326C7.21719 15.2326 6.05645 12.8882 8.21539 11.9609C10.3733 11.0325 12.6927 12.9226 13.7378 15.4295L14.4796 15.4202L14.4786 15.4191Z",
    fill: "url(#paint52_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M14.4786 15.4191C14.4786 15.4191 12.4853 9.40807 7.79756 11.2878C7.79756 11.2878 5.1364 12.3558 6.37425 15.2097L7.21719 15.2326C7.21719 15.2326 6.05645 12.8882 8.21539 11.9609C10.3733 11.0325 12.6927 12.9226 13.7378 15.4295L14.4796 15.4202L14.4786 15.4191Z",
    fill: "url(#paint53_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1104 15.3499L13.6908 15.3728C13.6908 15.3728 12.4373 10.2443 8.6321 11.8218C8.6321 11.8218 6.52005 12.8898 7.21608 15.2332L7.95899 15.28C7.95899 15.28 7.15981 13.2399 9.00303 12.3792C11.486 11.2185 13.2032 14.955 13.1104 15.3499Z",
    fill: "url(#paint54_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4988 15.4491C13.4988 15.4491 11.9973 11.1719 8.60888 13.8174C8.60888 13.8174 7.86596 14.6301 7.9587 15.2793H8.58491C8.58491 15.2793 8.6318 14.4905 9.07255 14.1883C9.5133 13.8862 11.4868 12.6733 12.8559 15.4585L13.4988 15.4491Z",
    fill: "url(#paint55_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1628 15.4306C13.2264 15.5307 12.5897 15.4306 12.5897 15.4306C12.5897 15.4306 9.97861 12.1714 8.30731 13.8187C8.30731 13.8187 7.84364 14.445 7.79675 15.2348H7.05383C7.05383 15.2348 7.21325 14.0303 7.74986 13.4478C8.30731 12.8445 10.9112 11.8807 13.1628 15.4306Z",
    fill: "url(#paint56_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6934 15.3031H11.9505C11.9505 15.3031 10.697 13.563 9.11948 14.4674C9.11948 14.4674 8.63184 14.7925 8.72458 15.3031L7.95874 15.2802C7.95874 15.2802 8.02855 14.5612 8.79439 14.1663C9.56023 13.7714 10.5584 13.0754 12.6934 15.3031Z",
    fill: "url(#paint57_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0169 15.4795C14.0169 15.4795 13.8283 14.4605 12.6061 14.6897C11.5037 14.896 10.1939 16.6194 8.56327 16.6653C6.93261 16.7111 5.53118 16.436 6.5648 15.0575C6.5648 15.0575 6.19699 14.598 5.78333 15.0805C5.36967 15.5629 4.70386 18.0438 8.83835 17.355C8.83835 17.355 10.171 17.2634 12.7894 15.3795C12.7894 15.3795 13.1072 15.1628 13.3573 15.467L14.0169 15.4806V15.4795Z",
    fill: "url(#paint58_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M14.0169 15.4795C14.0169 15.4795 13.8283 14.4605 12.6061 14.6897C11.5037 14.896 10.1939 16.6194 8.56327 16.6653C6.93261 16.7111 5.53118 16.436 6.5648 15.0575C6.5648 15.0575 6.19699 14.598 5.78333 15.0805C5.36967 15.5629 4.70386 18.0438 8.83835 17.355C8.83835 17.355 10.171 17.2634 12.7894 15.3795C12.7894 15.3795 13.1072 15.1628 13.3573 15.467L14.0169 15.4806V15.4795Z",
    fill: "url(#paint59_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5833 15.2193C10.5833 15.2193 11.0428 14.7369 11.3877 15.2881C11.3877 15.2881 8.58479 18.091 7.25212 16.7583C7.25212 16.7583 6.10389 15.7018 6.74678 15.0349C6.74678 15.0349 7.02289 14.7817 7.29797 15.1495C7.29797 15.1495 7.43551 16.2061 8.03359 16.4822C8.63063 16.7583 10.1467 15.8393 10.5833 15.2183V15.2193Z",
    fill: "url(#paint60_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M10.5833 15.2193C10.5833 15.2193 11.0428 14.7369 11.3877 15.2881C11.3877 15.2881 8.58479 18.091 7.25212 16.7583C7.25212 16.7583 6.10389 15.7018 6.74678 15.0349C6.74678 15.0349 7.02289 14.7817 7.29797 15.1495C7.29797 15.1495 7.43551 16.2061 8.03359 16.4822C8.63063 16.7583 10.1467 15.8393 10.5833 15.2183V15.2193Z",
    fill: "url(#paint61_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.067 15.1126C20.067 15.1126 22.2552 11.6731 24.7267 11.9325C27.1992 12.192 28.1526 12.4858 30.098 14.1852C30.098 14.1852 34.4471 17.0433 29.7833 19.9827C29.7833 19.9827 30.7586 20.1608 31.3733 19.817C31.3733 19.817 32.3236 19.3429 32.633 17.9113C32.9425 16.4796 32.4101 13.7434 28.6257 11.9971C28.6257 11.9971 24.4151 10.2206 22.0093 11.9648C22.0093 11.9648 20.2911 13.2047 19.4033 15.1782L20.067 15.1136V15.1126Z",
    fill: "url(#paint62_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M20.067 15.1126C20.067 15.1126 22.2552 11.6731 24.7267 11.9325C27.1992 12.192 28.1526 12.4858 30.098 14.1852C30.098 14.1852 34.4471 17.0433 29.7833 19.9827C29.7833 19.9827 30.7586 20.1608 31.3733 19.817C31.3733 19.817 32.3236 19.3429 32.633 17.9113C32.9425 16.4796 32.4101 13.7434 28.6257 11.9971C28.6257 11.9971 24.4151 10.2206 22.0093 11.9648C22.0093 11.9648 20.2911 13.2047 19.4033 15.1782L20.067 15.1136V15.1126Z",
    fill: "url(#paint63_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0658 15.1136C20.0418 15.345 21.1744 14.9563 21.1744 14.9563C21.1744 14.9563 23.1042 12.4056 25.5976 12.0201C25.5976 12.0201 23.8627 11.2709 21.7183 13.1589C21.7183 13.1589 20.0981 14.8063 20.0658 15.1126V15.1136Z",
    fill: "url(#paint64_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M20.0658 15.1136C20.0418 15.345 21.1744 14.9563 21.1744 14.9563C21.1744 14.9563 23.1042 12.4056 25.5976 12.0201C25.5976 12.0201 23.8627 11.2709 21.7183 13.1589C21.7183 13.1589 20.0981 14.8063 20.0658 15.1126V15.1136Z",
    fill: "url(#paint65_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9523 18.5463C30.9523 18.5463 32.3412 16.6114 29.7634 14.4369C29.7634 14.4369 28.4172 13.1355 26.8866 13.2396C26.8866 13.2396 25.9592 13.1907 23.5304 14.6661C21.1016 16.1425 18.8781 15.9654 18.8781 15.9654C18.8781 15.9654 17.4714 15.7174 17.5433 15.6091C17.5631 15.5799 18.2654 14.986 18.3342 14.887C18.3342 14.887 18.8093 15.3027 20.193 15.1245C20.193 15.1245 21.0026 15.236 24.7495 13.1136C24.7495 13.1136 26.5469 12.3384 27.3951 12.4207C27.9785 12.4832 32.7528 14.938 31.9328 17.4002C31.9328 17.4002 31.268 18.3484 30.9523 18.5463Z",
    fill: "url(#paint66_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M30.9675 18.5463C30.9675 18.5463 32.3564 16.6114 29.7786 14.4369C29.7786 14.4369 28.4324 13.1355 26.9018 13.2396C26.9018 13.2396 25.9745 13.1907 23.5457 14.6661C21.1169 16.1425 18.8933 15.9654 18.8933 15.9654C18.8933 15.9654 17.4867 15.7174 17.5586 15.6091C17.5784 15.5799 18.2807 14.986 18.3494 14.887C18.3494 14.887 18.8245 15.3027 20.2083 15.1245C20.2083 15.1245 21.0179 15.236 24.7647 13.1136C24.7647 13.1136 26.5621 12.3384 27.4103 12.4207C27.7625 12.3238 32.6284 14.8411 31.948 17.4002C31.948 17.4002 31.2832 18.3484 30.9675 18.5463Z",
    fill: "url(#paint67_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5975 12.0188C25.5975 12.0188 22.7874 12.8878 21.3609 14.7873C21.3609 14.7873 23.8908 13.7474 24.7504 13.1118C24.7504 13.1118 26.5603 12.2668 27.3959 12.4189C27.3959 12.4189 25.9205 11.9573 25.5975 12.0188Z",
    fill: "url(#paint68_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5975 12.0188C25.5975 12.0188 22.7874 12.8878 21.3609 14.7873C21.3609 14.7873 23.8908 13.7474 24.7504 13.1118C24.7504 13.1118 26.5603 12.2668 27.3959 12.4189C27.3959 12.4189 25.9205 11.9573 25.5975 12.0188Z",
    fill: "url(#paint69_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2619 15.65C33.0473 12.4907 27.5562 10.6246 25.3587 11.231C25.3587 11.231 32.793 12.8096 32.3981 16.0719C32.3981 16.0719 32.4773 17.4765 30.4205 19.0186C30.3413 19.1197 29.5692 19.4729 29.2139 19.4937C26.2871 19.8897 24.4866 15.3009 24.4866 15.3009C24.2292 15.0404 23.9645 15.0519 23.6957 15.3009C25.4754 20.7993 29.1347 20.2648 29.1347 20.2648C29.4963 20.2283 30.036 20.0866 30.3611 19.9282C31.2978 19.4896 33.4286 18.084 33.263 15.6489L33.2619 15.65Z",
    fill: "url(#paint70_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5646 11.7111C27.6443 10.4003 25.1967 11.2068 25.1967 11.2068C25.3759 11.1432 27.3806 11.5766 27.3806 11.5766C28.6216 11.8757 29.2864 12.5728 29.2864 12.5728C30.0606 13.3063 30.2398 15.46 29.3697 16.3103C29.1707 16.5572 27.8141 18.3858 25.0977 15.262C25.0977 15.262 24.6028 14.689 24.485 15.3016C24.485 15.3016 27.4119 20.1467 30.122 16.9042L30.1168 16.8979C31.4214 15.1902 31.1973 12.826 29.5646 11.7131V11.7111Z",
    fill: "url(#paint71_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M29.5646 11.7111C27.6443 10.4003 25.1967 11.2068 25.1967 11.2068C25.3759 11.1432 27.3806 11.5766 27.3806 11.5766C28.6216 11.8757 29.2864 12.5728 29.2864 12.5728C30.0606 13.3063 30.2398 15.46 29.3697 16.3103C29.1707 16.5572 27.8141 18.3858 25.0977 15.262C25.0977 15.262 24.6028 14.689 24.485 15.3016C24.485 15.3016 27.4119 20.1467 30.122 16.9042L30.1168 16.8979C31.4214 15.1902 31.1973 12.826 29.5646 11.7131V11.7111Z",
    fill: "url(#paint72_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.356 15.2817C25.356 15.2817 25.4748 14.8462 26.0479 15.0244L26.424 15.2421C26.424 15.2421 29.1477 17.2281 29.7635 14.4357L29.9636 14.6097C29.9636 14.6097 30.0823 16.0538 28.7768 16.8249C28.7768 16.8249 26.6012 16.8051 25.355 15.2817H25.356Z",
    fill: "url(#paint73_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.924 11.959L30.7742 12.3748C30.7742 12.3748 31.6047 9.03216 24.7028 9.96158C24.7028 9.96158 25.3154 10.4565 25.4144 10.693C25.4144 10.693 30.0626 10.1585 29.924 11.959Z",
    fill: "url(#paint74_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1864 15.1104C26.1864 15.1104 26.5823 14.9781 27.0304 15.1636C27.4784 15.348 29.0612 15.8231 29.404 15.322C29.404 15.322 28.5339 16.8516 26.1864 15.1115V15.1104Z",
    fill: "url(#paint75_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.78222 15.0812C5.78222 15.0812 5.51443 14.5144 4.71734 15.0656C4.71734 15.0656 3.16795 16.4597 5.03618 17.3787C5.03618 17.3787 3.84418 16.2294 5.78117 15.0812H5.78222Z",
    fill: "#A98757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.613 16.1909C22.613 16.1909 22.0722 16.9557 23.1006 16.7973C23.1006 16.7973 28.5459 13.5402 24.0238 10.3893C24.0238 10.3893 19.5673 7.63332 16.1789 14.4237C16.6186 14.2956 17.0093 14.2133 17.3063 14.2914C17.3063 14.2914 19.5017 9.65054 23.4966 11.1666C23.4966 11.1666 26.7266 13.237 22.613 16.1899V16.1909Z",
    fill: "url(#paint76_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M22.613 16.1909C22.613 16.1909 22.0722 16.9557 23.1006 16.7973C23.1006 16.7973 28.5459 13.5402 24.0238 10.3893C24.0238 10.3893 19.5673 7.63332 16.1789 14.4237C16.6186 14.2956 17.0093 14.2133 17.3063 14.2914C17.3063 14.2914 19.5017 9.65054 23.4966 11.1666C23.4966 11.1666 26.7266 13.237 22.613 16.1899V16.1909Z",
    fill: "url(#paint77_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0114 14.2521L17.7113 14.4595C17.7113 14.4595 17.5633 14.2917 17.3059 14.2917C17.3059 14.2917 16.7454 10.0332 14.9397 10.4281C13.0412 10.8439 12.7505 12.4589 12.7505 12.4589C12.7505 12.4589 12.3817 12.1297 12.2493 12.0109C12.2493 12.0109 13.0277 10.0728 14.7938 9.82173C14.7938 9.82173 17.4831 9.04338 18.0114 14.2521Z",
    fill: "url(#paint78_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M18.0114 14.2521L17.7113 14.4595C17.7113 14.4595 17.5633 14.2917 17.3059 14.2917C17.3059 14.2917 16.7454 10.0332 14.9397 10.4281C13.0412 10.8439 12.7505 12.4589 12.7505 12.4589C12.7505 12.4589 12.3817 12.1297 12.2493 12.0109C12.2493 12.0109 13.0277 10.0728 14.7938 9.82173C14.7938 9.82173 17.4831 9.04338 18.0114 14.2521Z",
    fill: "url(#paint79_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0116 14.2534L18.1564 14.1346C18.1564 14.1346 18.3012 7.47648 15.2025 8.88729C15.2025 8.88729 14.3064 9.28324 14.1084 9.99489C14.1084 9.99489 14.57 9.79692 14.9524 9.79692C14.9524 9.79692 15.5984 9.34888 16.3632 9.54685C16.3632 9.54685 17.2864 9.65209 18.0116 14.2544V14.2534Z",
    fill: "url(#paint80_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M18.0116 14.2534L18.1564 14.1346C18.1564 14.1346 18.3012 7.47648 15.2025 8.88729C15.2025 8.88729 14.3064 9.28324 14.1084 9.99489C14.1084 9.99489 14.57 9.79692 14.9524 9.79692C14.9524 9.79692 15.5984 9.34888 16.3632 9.54685C16.3632 9.54685 17.2864 9.65209 18.0116 14.2544V14.2534Z",
    fill: "url(#paint81_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0691 10.734C14.0222 10.7579 13.8055 13.3576 15.1903 14.9403L15.6123 14.7163C15.6123 14.7163 14.5443 13.1607 14.7818 10.4703C14.7818 10.4703 14.5318 10.4964 14.0702 10.734H14.0691Z",
    fill: "url(#paint82_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4975 15.2819C14.4975 15.2819 8.66251 10.9307 11.0361 9.62509C11.0361 9.62509 12.5323 8.93949 14.1078 9.99395C14.1078 9.99395 13.8046 10.119 13.5472 10.3367C13.5472 10.3367 12.4396 9.5855 11.3914 10.1388C11.3914 10.1388 10.8381 10.5347 11.6884 11.6819C11.6884 11.6819 13.2638 13.8711 15.1226 15.0183C15.1226 15.0183 14.6746 15.3215 14.4964 15.2819H14.4975Z",
    fill: "url(#paint83_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7821 15.4006C8.7821 15.4006 8.96028 14.965 9.53335 15.3016C10.1064 15.6381 11.2932 17.0812 13.2521 16.4686C15.2099 15.8559 16.0873 15.2557 16.0873 15.2557C16.0873 15.2557 16.6145 15.0838 16.5488 15.4006C16.5488 15.4006 14.3993 16.8645 13.3709 17.2594C13.3709 17.2594 10.345 18.169 8.7821 15.4006Z",
    fill: "url(#paint84_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M8.7821 15.4006C8.7821 15.4006 8.96028 14.965 9.53335 15.3016C10.1064 15.6381 11.2932 17.0812 13.2521 16.4686C15.2099 15.8559 16.0873 15.2557 16.0873 15.2557C16.0873 15.2557 16.6145 15.0838 16.5488 15.4006C16.5488 15.4006 14.3993 16.8645 13.3709 17.2594C13.3709 17.2594 10.345 18.169 8.7821 15.4006Z",
    fill: "url(#paint85_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30463 15.1762C7.30463 15.1762 7.15042 14.0968 7.77247 14.1666C8.19029 14.2135 8.65397 14.7469 8.65397 14.7469C8.65397 14.7469 10.2086 16.7663 14.7338 15.2575C14.7338 15.2575 13.9211 15.8837 13.597 15.9765C13.273 16.0692 10.2742 18.0072 7.30359 15.1762H7.30463Z",
    fill: "url(#paint86_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M7.30463 15.1762C7.30463 15.1762 7.15042 14.0968 7.77247 14.1666C8.19029 14.2135 8.65397 14.7469 8.65397 14.7469C8.65397 14.7469 10.2086 16.7663 14.7338 15.2575C14.7338 15.2575 13.9211 15.8837 13.597 15.9765C13.273 16.0692 10.2742 18.0072 7.30359 15.1762H7.30463Z",
    fill: "url(#paint87_linear_308_1148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4565 18.0428C20.4565 18.0428 19.849 17.0665 18.804 17.0394C18.804 17.0394 18.8633 16.5601 19.4145 16.6706C19.9657 16.781 20.6555 17.4896 20.6555 17.4896C20.6555 17.4896 20.8827 18.0856 20.4565 18.0428Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_308_1148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4103 22.4288C20.3276 22.4288 21.0712 21.6852 21.0712 20.7679C21.0712 19.8507 20.3276 19.1071 19.4103 19.1071C18.4931 19.1071 17.7495 19.8507 17.7495 20.7679C17.7495 21.6852 18.4931 22.4288 19.4103 22.4288Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.2177 21.5725C19.6585 21.5725 20.0159 21.2151 20.0159 20.7743C20.0159 20.3335 19.6585 19.9762 19.2177 19.9762C18.7769 19.9762 18.4196 20.3335 18.4196 20.7743C18.4196 21.2151 18.7769 21.5725 19.2177 21.5725Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2804 17.352C14.2804 17.352 13.1332 17.4312 12.6195 18.3408C12.6195 18.3408 12.2236 18.0636 12.5799 17.6291C12.9363 17.1936 13.8855 16.9175 13.8855 16.9175C13.8855 16.9175 14.518 16.9967 14.2815 17.353L14.2804 17.352Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_308_1148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6099 23.0077C15.5272 23.0077 16.2708 22.2641 16.2708 21.3468C16.2708 20.4295 15.5272 19.6859 14.6099 19.6859C13.6927 19.6859 12.9491 20.4295 12.9491 21.3468C12.9491 22.2641 13.6927 23.0077 14.6099 23.0077Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.8662 22.1261C15.307 22.1261 15.6644 21.7687 15.6644 21.3279C15.6644 20.8871 15.307 20.5298 14.8662 20.5298C14.4254 20.5298 14.0681 20.8871 14.0681 21.3279C14.0681 21.7687 14.4254 22.1261 14.8662 22.1261Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_308_1148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6827 23.5366C18.6567 24.2285 18.0867 24.7828 17.3886 24.7828C16.6905 24.7828 16.1205 24.2285 16.0945 23.5366H15.7058C15.7319 24.4421 16.4758 25.1715 17.3886 25.1715C18.3014 25.1715 19.0453 24.4421 19.0714 23.5366H18.6827Z",
    fill: "#231F20"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0072 20.6239L45.4188 11.7063H42.2018V27.4862H46.312V18.5332L53.9005 27.4862H57.1648V11.7063H53.0072V20.6239Z",
    fill: "#F9BD2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9399 17.547C91.6607 17.1618 91.2818 16.829 90.8001 16.5501C90.0718 16.1295 89.2537 15.9184 88.3457 15.9184C87.3268 15.9184 86.4188 16.1588 85.6203 16.6395C84.8218 17.1202 84.1996 17.7996 83.7522 18.6778C83.3064 19.5576 83.0827 20.5806 83.0827 21.7469C83.0827 22.9132 83.3097 23.964 83.7636 24.8499C84.2176 25.7358 84.8398 26.4276 85.6317 26.9222C86.4221 27.4167 87.3268 27.6648 88.3441 27.6648C89.252 27.6648 90.0702 27.466 90.7985 27.067C91.321 26.7804 91.7227 26.4168 92.0085 25.9777V27.4891H96.1906V11.1761H91.9383V17.547H91.9399ZM91.3994 23.9409C90.9912 24.4277 90.4131 24.6727 89.6603 24.6727C88.9075 24.6727 88.3441 24.4216 87.9212 23.9193C87.4982 23.4171 87.2876 22.6929 87.2876 21.7469C87.2876 20.8009 87.4901 20.1554 87.8983 19.6747C88.3049 19.194 88.8928 18.9536 89.6603 18.9536C90.4278 18.9536 90.9716 19.2017 91.3863 19.6962C91.8011 20.1908 92.0085 20.8903 92.0085 21.7901C92.0085 22.7361 91.8044 23.4525 91.3978 23.9393L91.3994 23.9409Z",
    fill: "#F9BD2A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.511 11.1743H98.2583V27.4873H102.511V11.1743Z",
    fill: "#F9BD2A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112.977 16.6268C112.139 16.1538 111.148 15.9181 110.005 15.9181C108.862 15.9181 107.797 16.1692 106.904 16.6715C106.011 17.1738 105.31 17.8686 104.801 18.7545C104.291 19.6404 104.036 20.6604 104.036 21.8128C104.036 22.9653 104.303 24.0484 104.835 24.9266C105.367 25.8063 106.13 26.4812 107.126 26.9542C108.121 27.4272 109.306 27.6629 110.684 27.6629C111.53 27.6629 112.376 27.5489 113.222 27.3193C114.068 27.0897 114.788 26.7616 115.384 26.3333L114.303 23.674C113.833 23.9991 113.297 24.2549 112.695 24.4382C112.092 24.6231 111.493 24.7155 110.898 24.7155C109.912 24.7155 109.19 24.469 108.736 23.9729C108.39 23.5954 108.176 23.0223 108.094 22.255H115.596V21.7235C115.596 20.5418 115.369 19.5141 114.915 18.6421C114.461 17.77 113.815 17.0983 112.977 16.6253V16.6268ZM110.123 18.6667C110.733 18.6667 111.199 18.8624 111.52 19.2537C111.747 19.531 111.893 19.9131 111.96 20.3954H108.156C108.243 19.9748 108.385 19.6297 108.584 19.3647C108.937 18.8994 109.45 18.6667 110.123 18.6667Z",
    fill: "#F9BD2A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8234 16.6377C76.7675 15.6285 73.9539 15.627 71.8931 16.6377C71.2383 16.9597 70.6863 17.3711 70.2307 17.8718C68.8574 16.5915 67.2261 15.9182 65.2959 15.9182C63.3657 15.9182 61.4927 16.4466 60.2075 17.8086C59.3731 18.6945 58.893 19.8516 58.7672 21.0318C58.6301 22.3291 58.8505 23.7881 59.5413 24.9267C60.0736 25.8064 60.8297 26.4813 61.8078 26.9543C62.786 27.4272 63.9487 27.663 65.2959 27.663C66.6431 27.663 68.9701 26.9666 70.0119 24.9251C70.0184 24.9144 70.025 24.902 70.0331 24.8897C70.1278 25.0623 70.2291 25.2302 70.3401 25.3889C71.4995 27.0544 73.8314 27.7739 75.8629 27.6799C77.5269 27.6029 79.2252 26.9928 80.378 25.8311C82.1531 24.0454 82.2625 20.9378 80.9937 18.7238C80.4858 17.8364 79.7559 17.0937 78.8234 16.6362V16.6377ZM68.2336 21.608C68.2222 21.5864 68.2058 21.5587 68.1862 21.5264C68.0801 22.0255 67.9413 22.6172 67.6441 23.104C67.1526 23.9083 66.4961 24.6709 65.2959 24.6709C64.5284 24.6709 63.9454 24.4414 63.5453 23.9838C63.1453 23.5262 62.946 22.7944 62.946 21.7898C62.946 20.7853 63.1453 20.0765 63.5453 19.6174C63.9454 19.1598 64.5284 18.9303 65.2959 18.9303C66.5337 18.9303 67.5282 19.4926 68.1356 20.2738C69.024 21.417 69.3865 22.4415 69.8029 24.0161C69.86 24.124 68.5226 22.1657 68.232 21.6065L68.2336 21.608ZM77.2672 23.7065C77.2068 23.7974 77.1382 23.8836 77.0631 23.9653C76.2368 24.8589 74.6969 24.7002 73.8298 23.9514C73.0509 23.2797 72.8321 22.3198 72.4499 21.4401C72.2001 20.8623 71.916 20.303 71.5992 19.7561C71.4832 19.5543 71.3673 19.3524 71.2579 19.149C71.1876 19.0165 71.075 18.8563 71.0554 18.7069C71.0358 18.5451 71.6057 19.2353 71.6955 19.3308C72.027 19.6852 72.2932 20.0658 72.5496 20.4694C73.1848 19.5712 74.1597 18.9688 75.3256 18.9657C76.3315 18.9626 77.2117 19.468 77.5056 20.4016C77.811 21.3692 77.8551 22.8236 77.2672 23.7065Z",
    fill: "#F9BD2A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M119.266 27.8529H123.329V21.0834H129.743V17.6621H123.329V14.6169H130.181V11.1743H119.266V27.8529Z",
    fill: "#000866"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M139.055 17.4648C138.789 17.0039 138.413 16.6131 137.923 16.2923C137.242 15.8477 136.477 15.6246 135.629 15.6246C134.676 15.6246 133.831 15.8901 133.091 16.4209C132.352 16.9518 131.769 17.6895 131.344 18.634C130.92 19.5785 130.708 20.6761 130.708 21.9251C130.708 23.1741 130.917 24.2359 131.334 25.1576C131.75 26.0793 132.334 26.7893 133.08 27.2892C133.827 27.7892 134.676 28.0383 135.629 28.0383C136.477 28.0383 137.242 27.8283 137.923 27.4065C138.412 27.1036 138.788 26.7193 139.055 26.2552V27.8527H142.965V15.952H139.055V17.4632V17.4648ZM138.473 24.104C138.085 24.6186 137.546 24.8775 136.859 24.8775C136.172 24.8775 135.592 24.6235 135.212 24.1154C134.832 23.6073 134.641 22.8778 134.641 21.9251C134.641 20.9725 134.839 20.1794 135.233 19.6404C135.629 19.1014 136.171 18.8327 136.858 18.8327C137.545 18.8327 138.102 19.09 138.482 19.6062C138.862 20.1208 139.053 20.8797 139.053 21.8779C139.053 22.8761 138.859 23.5878 138.472 24.104H138.473Z",
    fill: "#000866"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M150.613 18.8574C151.095 18.8574 151.601 18.96 152.129 19.162C152.656 19.3655 153.117 19.6391 153.512 19.9827L154.523 17.0547C154.054 16.6183 153.425 16.2698 152.634 16.0125C151.843 15.7552 151.039 15.6266 150.219 15.6266C148.975 15.6266 147.887 15.8888 146.958 16.4115C146.028 16.9342 145.303 17.6687 144.783 18.6132C144.264 19.5577 144.003 20.6634 144.003 21.9287C144.003 23.194 144.241 24.2639 144.718 25.1856C145.194 26.1073 145.886 26.8141 146.793 27.3059C147.701 27.7976 148.784 28.0435 150.043 28.0435C150.937 28.0435 151.782 27.9181 152.581 27.669C153.379 27.4198 154.027 27.0681 154.525 26.6154L153.514 23.7347C153.118 24.0945 152.657 24.3714 152.131 24.5668C151.604 24.7622 151.106 24.8599 150.637 24.8599C149.817 24.8599 149.184 24.614 148.738 24.1222C148.291 23.6304 148.068 22.8683 148.068 21.8375C148.068 20.8067 148.294 20.0723 148.749 19.5886C149.202 19.105 149.825 18.8623 150.616 18.8623L150.613 18.8574Z",
    fill: "#000866"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M163.171 24.6185C162.878 24.6185 162.608 24.5599 162.359 24.4427C162.11 24.3254 161.908 24.1381 161.754 23.8808C161.6 23.6235 161.524 23.2995 161.524 22.9087V19.0671H164.203V15.9519H161.524V11.8987L157.548 13.2568V15.9503H155.461V19.0655H157.548V22.907C157.548 24.485 157.933 25.734 158.701 26.6557C159.469 27.5774 160.623 28.0383 162.16 28.0383C162.527 28.0383 162.878 28.0155 163.214 27.9682C163.551 27.921 163.887 27.8282 164.225 27.6865V24.4769C164.005 24.5241 163.811 24.5583 163.643 24.5827C163.475 24.6055 163.316 24.6185 163.171 24.6185Z",
    fill: "#000866"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M174.121 16.3848C173.206 15.8767 172.133 15.6227 170.904 15.6227C169.675 15.6227 168.557 15.8767 167.642 16.3848C166.728 16.8929 166.021 17.611 165.523 18.5392C165.025 19.4691 164.776 20.565 164.776 21.8303C164.776 23.0956 165.025 24.216 165.523 25.1459C166.021 26.0757 166.728 26.789 167.642 27.2889C168.557 27.7888 169.644 28.038 170.904 28.038C172.163 28.038 173.206 27.7888 174.121 27.2889C175.035 26.789 175.742 26.0741 176.24 25.1459C176.738 24.216 176.986 23.1119 176.986 21.8303C176.986 20.5487 176.738 19.4691 176.24 18.5392C175.742 17.611 175.035 16.8912 174.121 16.3848ZM172.495 24.1509C172.12 24.6345 171.591 24.8772 170.902 24.8772C170.213 24.8772 169.639 24.6345 169.265 24.1509C168.891 23.6672 168.705 22.8937 168.705 21.832C168.705 20.7702 168.891 20.0211 169.265 19.5358C169.638 19.0522 170.184 18.8096 170.902 18.8096C171.62 18.8096 172.139 19.0522 172.505 19.5358C172.872 20.0195 173.055 20.7849 173.055 21.832C173.055 22.8791 172.869 23.6672 172.495 24.1509Z",
    fill: "#000866"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M184.88 15.671C184.031 15.671 183.272 15.9446 182.606 16.4918C182.161 16.8582 181.832 17.3467 181.62 17.9509L181.388 15.9527H177.653C177.727 16.5146 177.774 17.0845 177.797 17.6626C177.818 18.2407 177.831 18.8107 177.831 19.3725V27.8535H181.806V21.8803C181.806 21.2876 181.909 20.8023 182.113 20.4277C182.318 20.0532 182.603 19.7763 182.97 19.5956C183.336 19.4165 183.782 19.3269 184.309 19.3269C184.895 19.3269 185.503 19.4832 186.132 19.7959V15.9299C185.985 15.8518 185.81 15.7899 185.605 15.7427C185.4 15.6954 185.158 15.6727 184.88 15.6727V15.671Z",
    fill: "#000866"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M196.09 15.9522L193.494 22.8226L190.995 15.9522H186.866L191.409 27.0306L191.126 27.6884C190.951 28.0793 190.723 28.418 190.445 28.7079C190.167 28.9961 189.804 29.242 189.358 29.4456C188.911 29.6491 188.344 29.8201 187.656 29.9601L188.578 33.1926C189.5 33.0835 190.349 32.8572 191.126 32.5136C191.902 32.17 192.604 31.6619 193.235 30.991C193.864 30.32 194.413 29.413 194.882 28.2731L200 15.9506H196.09V15.9522Z",
    fill: "#000866"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_308_1148",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_308_1148",
    transform: "scale(0.0181818 0.00531915)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_308_1148",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_308_1148",
    transform: "scale(0.0178571 0.00529101)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2_308_1148",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_308_1148",
    transform: "scale(0.0153846 0.00564972)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3_308_1148",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image3_308_1148",
    transform: "scale(0.00460829 0.0119048)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_308_1148",
    x: 16.2925,
    y: 18.0664,
    width: 5.40312,
    height: 5.40315,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.416275
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.520344
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.168627 0 0 0 0 0.152941 0 0 0 0.31 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_308_1148"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_308_1148",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_308_1148",
    x: 11.4921,
    y: 18.6452,
    width: 5.40312,
    height: 5.40315,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.416275
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.520344
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.168627 0 0 0 0 0.152941 0 0 0 0.31 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_308_1148"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_308_1148",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_308_1148",
    x: 15.3936,
    y: 23.5366,
    width: 3.78178,
    height: 2.05116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.104069,
    dy: 0.208138
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.104069
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.168627 0 0 0 0 0.152941 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_308_1148"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_308_1148",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_308_1148",
    x1: 18.8173,
    y1: 28.6158,
    x2: 16.6604,
    y2: 32.3513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F3E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB884A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_308_1148",
    x1: 16.7848,
    y1: 14.8091,
    x2: 16.7848,
    y2: 28.9349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC7D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB884A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_308_1148",
    x1: 8.20106,
    y1: 15.0862,
    x2: 8.20106,
    y2: 21.5338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB884A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_308_1148",
    x1: 7.60701,
    y1: 15.1256,
    x2: 7.60701,
    y2: 17.7753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB884A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_308_1148",
    x1: 9.2932,
    y1: 15.2026,
    x2: 9.2932,
    y2: 19.5143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB884A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_308_1148",
    x1: 11.357,
    y1: 15.2815,
    x2: 11.357,
    y2: 19.5139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB884A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_308_1148",
    x1: 16.0622,
    y1: 15.2815,
    x2: 16.0622,
    y2: 20.3048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB884A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_308_1148",
    x1: 20.1143,
    y1: 15.165,
    x2: 20.1143,
    y2: 19.0015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB884A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_308_1148",
    x1: 24.0643,
    y1: 15.1256,
    x2: 24.0643,
    y2: 19.9509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB884A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_308_1148",
    x1: 24.0025,
    y1: 14.8872,
    x2: 24.0025,
    y2: 17.7234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB884A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_308_1148",
    x1: 27.3533,
    y1: 14.8386,
    x2: 27.3533,
    y2: 19.8431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB884A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_308_1148",
    x1: 23.9244,
    y1: 15.7473,
    x2: 23.9244,
    y2: 18.4074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB884A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_308_1148",
    x1: 15.5783,
    y1: 15.7908,
    x2: 15.5783,
    y2: 18.2102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB884A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_308_1148",
    x1: 19.6918,
    y1: 15.901,
    x2: 19.6918,
    y2: 18.2099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB884A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_308_1148",
    x1: 10.7932,
    y1: 16.1451,
    x2: 10.7932,
    y2: 18.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB884A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_308_1148",
    x1: 6.94992,
    y1: 14.4257,
    x2: 17.8009,
    y2: 14.4257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_308_1148",
    x1: 7.96307,
    y1: 14.4798,
    x2: 15.7705,
    y2: 14.4798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_308_1148",
    x1: 8.60648,
    y1: 15.3707,
    x2: 13.8673,
    y2: 15.3707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_308_1148",
    x1: 9.29279,
    y1: 12.93,
    x2: 14.5536,
    y2: 12.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_308_1148",
    x1: 13.4454,
    y1: 13.154,
    x2: 18.7062,
    y2: 13.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_308_1148",
    x1: 16.307,
    y1: 13.4432,
    x2: 21.5678,
    y2: 13.4432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_308_1148",
    x1: 14.8099,
    y1: 13.8357,
    x2: 21.1033,
    y2: 13.8357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_308_1148",
    x1: 14.8099,
    y1: 13.8357,
    x2: 21.1033,
    y2: 13.8357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B2314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDB46F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_308_1148",
    x1: 17.7557,
    y1: 12.6343,
    x2: 24.2148,
    y2: 12.6343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_308_1148",
    x1: 14.353,
    y1: 12.0298,
    x2: 20.8121,
    y2: 12.0298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_308_1148",
    x1: 19.2554,
    y1: 12.2652,
    x2: 24.5579,
    y2: 12.2652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_308_1148",
    x1: 21.4955,
    y1: 15.2342,
    x2: 27.7858,
    y2: 15.2342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_308_1148",
    x1: 21.0105,
    y1: 15.3866,
    x2: 27.4456,
    y2: 15.3866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_308_1148",
    x1: 21.0105,
    y1: 15.3866,
    x2: 27.4456,
    y2: 15.3866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B2314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDB46F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_308_1148",
    x1: 24.8739,
    y1: 15.2973,
    x2: 30.7255,
    y2: 15.2973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_308_1148",
    x1: 25.0002,
    y1: 14.4664,
    x2: 29.963,
    y2: 14.4664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_308_1148",
    x1: 25.0118,
    y1: 14.7978,
    x2: 29.4412,
    y2: 14.7978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_308_1148",
    x1: 25.0118,
    y1: 14.7978,
    x2: 29.4412,
    y2: 14.7978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3B2314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_308_1148",
    x1: 25.3165,
    y1: 15.0258,
    x2: 28.7049,
    y2: 15.0258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_308_1148",
    x1: 25.3165,
    y1: 15.0258,
    x2: 28.7049,
    y2: 15.0258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B2314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDB46F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_308_1148",
    x1: 24.1465,
    y1: 15.1619,
    x2: 28.6769,
    y2: 15.1619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62451F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A37742"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_308_1148",
    x1: 23.4325,
    y1: 15.1278,
    x2: 28.8517,
    y2: 15.1278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_308_1148",
    x1: 23.4325,
    y1: 15.1278,
    x2: 28.8517,
    y2: 15.1278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3B2314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_308_1148",
    x1: 8.80179,
    y1: 14.2447,
    x2: 20.0664,
    y2: 14.2447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_308_1148",
    x1: 18.6903,
    y1: 12.9675,
    x2: 24.2877,
    y2: 12.9675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_308_1148",
    x1: 23.1072,
    y1: 10.0535,
    x2: 19.6927,
    y2: 15.9656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3B2314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_308_1148",
    x1: 21.6899,
    y1: 8.18221,
    x2: 15.5059,
    y2: 18.8935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_308_1148",
    x1: 5.68488,
    y1: 12.8362,
    x2: 20.1431,
    y2: 12.8362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_308_1148",
    x1: 4.31616,
    y1: 12.9339,
    x2: 10.5356,
    y2: 12.9339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_308_1148",
    x1: 0.544573,
    y1: 17.3913,
    x2: 20.173,
    y2: 17.3913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_308_1148",
    x1: 0.544573,
    y1: 17.3913,
    x2: 20.173,
    y2: 17.3913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3B2314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_308_1148",
    x1: 10.3588,
    y1: 13.534,
    x2: 10.3588,
    y2: 21.2497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B2314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDB46F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_308_1148",
    x1: 1.42617,
    y1: 16.3818,
    x2: 19.5281,
    y2: 16.3818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_308_1148",
    x1: 1.42617,
    y1: 16.3818,
    x2: 19.5281,
    y2: 16.3818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3B2314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_308_1148",
    x1: 14.2659,
    y1: 14.751,
    x2: 16.4551,
    y2: 14.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_308_1148",
    x1: 3.34311,
    y1: 16.4005,
    x2: 17.7117,
    y2: 16.4005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_308_1148",
    x1: 3.34311,
    y1: 16.4005,
    x2: 17.7117,
    y2: 16.4005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3B2314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_308_1148",
    x1: 6.04499,
    y1: 13.1768,
    x2: 14.4786,
    y2: 13.1768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_308_1148",
    x1: 10.2618,
    y1: 15.4295,
    x2: 10.2618,
    y2: 10.9241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C3928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CDB46F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_308_1148",
    x1: 7.07541,
    y1: 13.4462,
    x2: 13.6908,
    y2: 13.4462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D592E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_308_1148",
    x1: 7.9514,
    y1: 14.206,
    x2: 13.4988,
    y2: 14.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_308_1148",
    x1: 7.05383,
    y1: 14.1657,
    x2: 13.167,
    y2: 14.1657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A87C4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_308_1148",
    x1: 7.95978,
    y1: 14.5237,
    x2: 12.6934,
    y2: 14.5237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_308_1148",
    x1: 5.47179,
    y1: 16.0661,
    x2: 14.0169,
    y2: 16.0661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_308_1148",
    x1: 5.47179,
    y1: 16.0661,
    x2: 14.0169,
    y2: 16.0661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3B2314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_308_1148",
    x1: 6.55193,
    y1: 16.0341,
    x2: 11.3877,
    y2: 16.0341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_308_1148",
    x1: 6.55193,
    y1: 16.0341,
    x2: 11.3877,
    y2: 16.0341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#CDB46F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3B2314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_308_1148",
    x1: 19.4033,
    y1: 15.6127,
    x2: 32.7081,
    y2: 15.6127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A17440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#CDB46F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_308_1148",
    x1: 19.4033,
    y1: 15.6127,
    x2: 32.7081,
    y2: 15.6127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B2314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDB46F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_308_1148",
    x1: 20.0648,
    y1: 13.5299,
    x2: 25.5976,
    y2: 13.5299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_308_1148",
    x1: 20.0648,
    y1: 13.5299,
    x2: 25.5976,
    y2: 13.5299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B2314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDB46F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_308_1148",
    x1: 17.5402,
    y1: 15.4809,
    x2: 32.0286,
    y2: 15.4809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_308_1148",
    x1: 17.5554,
    y1: 15.4809,
    x2: 32.0136,
    y2: 15.4809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B2314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDB46F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_308_1148",
    x1: 21.3599,
    y1: 13.4005,
    x2: 27.3959,
    y2: 13.4005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_308_1148",
    x1: 21.3599,
    y1: 13.4005,
    x2: 27.3959,
    y2: 13.4005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B2314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDB46F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_308_1148",
    x1: 23.6947,
    y1: 15.6989,
    x2: 33.2713,
    y2: 15.6989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A17440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDB46F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_308_1148",
    x1: 24.4861,
    y1: 14.491,
    x2: 30.9608,
    y2: 14.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A17440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCB985"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_308_1148",
    x1: 24.4861,
    y1: 14.491,
    x2: 30.9608,
    y2: 14.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B2314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDB46F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_308_1148",
    x1: 25.356,
    y1: 15.6298,
    x2: 29.9667,
    y2: 15.6298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_308_1148",
    x1: 24.7028,
    y1: 11.0869,
    x2: 30.8065,
    y2: 11.0869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A17440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CDB46F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_308_1148",
    x1: 26.1864,
    y1: 15.5033,
    x2: 29.404,
    y2: 15.5033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_308_1148",
    x1: 20.999,
    y1: 16.8192,
    x2: 20.999,
    y2: 9.83706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A17440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEB868"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_308_1148",
    x1: 16.1779,
    y1: 13.3276,
    x2: 25.8191,
    y2: 13.3276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C3928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CDB46F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_308_1148",
    x1: 12.2493,
    y1: 12.1203,
    x2: 18.0114,
    y2: 12.1203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_308_1148",
    x1: 12.2493,
    y1: 12.1203,
    x2: 18.0114,
    y2: 12.1203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#5A3B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_308_1148",
    x1: 14.1094,
    y1: 11.4724,
    x2: 18.1574,
    y2: 11.4724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_308_1148",
    x1: 14.1094,
    y1: 11.4724,
    x2: 18.1574,
    y2: 11.4724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3B2314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_308_1148",
    x1: 14.0285,
    y1: 12.7043,
    x2: 15.6112,
    y2: 12.7043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_308_1148",
    x1: 10.4682,
    y1: 12.3467,
    x2: 15.1237,
    y2: 12.3467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_308_1148",
    x1: 8.7821,
    y1: 16.2883,
    x2: 16.5541,
    y2: 16.2883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_308_1148",
    x1: 8.7821,
    y1: 16.2883,
    x2: 16.5541,
    y2: 16.2883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3B2314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_308_1148",
    x1: 7.28796,
    y1: 15.4367,
    x2: 14.7348,
    y2: 15.4367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_308_1148",
    x1: 7.28796,
    y1: 15.4367,
    x2: 14.7348,
    y2: 15.4367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3B2314"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_308_1148",
    width: 55,
    height: 188,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_308_1148",
    width: 56,
    height: 189,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_308_1148",
    width: 65,
    height: 177,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAACxCAYAAACbZdBcAAAACXBIWXMAAA4mAAAOJgGi7yX8AAAJ3klEQVR4nO1d25KrOAxsMvP/X7wT9uGgOUK0ZNkYImq3qygbQzK40aVlksyCDeu6LvgL3UdifPX2l2Wxx8phAX4JWNSYR0iGhFVtv8cqk/Gt+kuwgbQaK9neMERUxbdjBa9tW1QL0loLeKt22do3qpOg+pqAL+yJiNxF3/1Ftfq4jJfE97Isq7IGbQXMGiwBwN/J6buvj7HXlMK32feIaJGwOsdf2JNSEowEPWFxDTuuoQOhPfb7mnVdl6oZwpIA+MGRWYONB/quv9Xrfi649mlgliCtFx8sCcAxA6z46wr6dY+yBGm9dGkt4YX9BO3kS8cGRgLABZMmQ86xlrBiP2mmNcpBSLBmynSBpyKt6QMPIgDYWwLzV0bEKzhP3ofFg7IZwpKgL7BVS+jztBvoOBGl1jLwYgIDK6Y05O5nySuDF5Aqc70YYdNmZisHawnWJYD9hbPJeMcfS4IgQ4a0es2ApVXbLwcd6e2KEAOLCzZreBrjN0NMufKJYO7AwEzejjNLiFynDDxLYGuGFtlYUToeAFz4eGQAXCN4yhKNY2UQZYdWfNCIJLYNjuXwe1FGK/ToBu9YpC1KwV5Qa/KZ2KD7dvIl06QXE6JWw95p29f7v1u1NOmZ5uhDk5Z6tOeUAHMHRkCGjCg4lk6XUYq0/QxaqbEcAYBvCUwweYhEkj2nZIbIiCVrFSOuIf2SCyw7EjatECnGDCJLsOMlkMkOWULYHfZiQqk0mdUJPRaSqSLLEADEljDDJaTvFVUlkEmRuu1BVGGWzw6AnxVa1pEpo8sR0buekEWUIcoVUj0xoVcwtWRzXRKMVhBkY0M04bJpMvLL2dmBPdUuTQJbaO3NFI+uIgW91WTk96xfJji20lRUTbaW2mSfkVOqkMpkBwQtQ1YnPIIE/REckDZCmogKGSKbHaLg6N3RLBEfR0a6jj6EkTajHT4KSkJSMEX1g20fGROA2A0ymUGPMVmtPyT6UfS4g6cgs/pB/l45a8jqBM89WiV1JJYeQUIUE3qfRZQupFok2K/vjBBg9x9lCUDeFaQvAU+DuYYdL2sJGp4lRLVEq47QYzVJIFqhJyuwT7KBjNUmYYMnnVvVJENZ0dTrDnaslwDdfxQJ3tJ7FtYVdL9Emhx1h+x7e1Las4yPYFQx9pLiTfTjBAA5d9CLKyP1QyYzlLYEwVn5XDpNhiQEH9o4QwTbPlpS91hCSzx57x+lx8MXxZLXMxW9KdKOefsMkRXUdQcFTQQLlMDRNSJ9IG2JuDCysgTk4wBwnLTXfxQJTCtY2GpRj7NJlycBaJt+SyewMtoeewwJQJ8rWLTiQU0SiFYAuHs030q17vaJNNkjUEYtwasZ7PG6lrAhCoYZcjJZwQuml6PXErzF1h6tkAmSt2JUNo8Gx1Zc+MinV0azQ4aQSCtIW6KQ6nUHK5n1sTNawX6q7VaMxISMYszAdYW702SKBPIjEywg2ta+ppUV7LHb8PHPBlTAqDu0VpssrL9n9MJtOEuCPpZFKzuUd4dWcMxkCOA4yY9aw9nsYI9nkBFMt8aqUdk80zVo/XBnmhxxB08wAe3gyKzAHi8dGIG56wp6n7lDPUvoEEypt0tut2CGJbBzLCJ9YI/fnibPkMAkMiOHTYbFBvsDNLdliJ5f4dMYyQrsrkv7OHd4q34knyNkCLgtTZ51hxGN4KXJRyhGgdYKsp9Nka2Jf8QlRknIpMeeOuI5JJBf5WqV17uXB2NRtrgcZyyBWUEmPvS4xC1p8iwJ0XKaRnTHQcbquoNCKzuMSGg2dkuanBEYR3QCkA+Il5MwohijANijE+zYY91B93sJaMWF2wqp2TEBZF/g+b302Tflbimkuv+A0gpZ0XR4C8Q+/xhLsGBZIlNVprarM8RMd+hJixaRWCprCd6dHhVNun97ljjrDr2LrIA/aTjjZUmI3KF3fUHwSEuICOiND61q8tI0eWaN0fugtz7HQ09M0OdfgiGGG18GGckSjJTd/pVpclZgBMaI8O72o2KCtF5Z3UOGtLcHxxmWoFvpj8ho6ga4QT7PyA56wuz/v2ULKhmLrOISzCKhp7SOfN+OvVR7WZqcqRh7qsrICrz6oawlRN+ePbPeSK3jqjQ5TILSCuwfZlq0hBNLlbdliBl+dsYK2ITt/uWfXJmZIrNuIa03qdu1wixL0K091nKVqFZgQXI6Zq8nROoxg5YVlLQEzw3OLLlFCvKSDHFFYBxJkd5dfowleFohKrFbIupWl5hlCez3XL3iykPoBrhQOZ4igTyI6SGiRYj3RKoWCQYtzdC7tqD3L02TVwXG1sf8GFpldPmYkAmG9vwW3JJ7dpqcHRjZ1wB6XYJN3vanYnTJXYO5Auv36gbdZ9uIEKOY+VSaTR7YX2zPhd8WF2Y/mm9tIG0GtUlwHsT0EMHI8OKAXl+YhhkxAegjQU96Me+hx7y4YI+dxmyx1NrsUpx+LYMlwo5NweyYoFNlq7DKpk0qomZqhSuyg80SHiFAmwCNy4LjTHewE2aTR7DPcEuanEICWX7vcQeBDZhePJi++jw7MEbWYEmJvmkr8NYTplaTV5LAFKRdfAF8Aiz05F8AXrOC4zQSlEv84EiGFyC9kvvw9qqdvsAye4GCZQVrBS0iBEwgWQKmXP9sEt7wLSEKnJ6IAvzMMM0lrniiE7kEs4SMfjjEA7OdwlQSTKr0CIjEExBbhLSyfWFCXLjCEqLJj+oGAbWIdV1PzWNWFWmhXeIHfy5WiLABj03AcwcWHL/Uew9huiVsLhGlyMglWIpk5s6sYdgtrrQEsQJ9p8QSxDIEkTXYtMl+Z+G1/Z1/Ri72kuf9yhp+sHcLT01Gxdbv2+IYHDUJw+X1VZYA7CcoceEHfy5eWg17QyL3OOgFtf30XujVJEiA/MI+QAoR2Ppv1dfL6S3dwOqJN/kRnBCXkbAsy7quq7YAbQlsEjpzCDICiknpLmu40hKAv5agzVXcg60Z6I0twmSU5Htd19eyLOmUeSkJmzXomKAju71bdr0A6CNCk7Gu67pk3eJqSwCOATJaIntt5zOXiAjQfe1aNUgw1hCtD8okWVwA4pUoS0CXNdxhCViW5b0FSWsF4hJ6cjpVRrEhWoD53dZ1ZT+ZtsMtJGwQawCOlsAm1jrHew1ztxokKLcA2hP0lJ9dkfKsQf7GgoRb3GkJ4hbAMTN8YT85G/CYePJKdGBP4gIAkVvcSsIGuXg7JoWW/aheK1161ai8tkZg1FBuoS9OLMEqRy+LALlluv0LHbc4vTQ1iq3ik7T2haOY8kgA4owRWcYK4OAWn3AHqAtZtxghVmDXCgAeRKWNFGW6iPqYJWgYq7CxIHIJ3Wdj9Li1hBIkCBQZI9fl3fljDOgstf/HfwX/Aq8jpAa/zVl4AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image3_308_1148",
    width: 217,
    height: 84,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.eb4ac6e8d44f6886b0491fe83d11c379.svg";
export { ForwardRef as ReactComponent };